import { EventRoleWithMemberships, fetchRegisteredEvents } from '@modules/supabase/events';
import { Column } from '@material-table/core';
import EventsList from './EventsList';
import { RegistrationStatusColumn } from '@atoms/RegistrationStatusColumn';

export default function MyRegisteredEvents() {
    return <EventsList fetchEvents={fetchRegisteredEvents} columns={COLUMNS} />;
}
const COLUMNS: Column<EventRoleWithMemberships>[] = [RegistrationStatusColumn];
